module.exports = __webpack_public_path__ + "static/media/icefields-10.bbb3d805.jpg";